<page-heading
  [title]="'tag.list.pageTitle' | translate"
  [description]="'tag.list.pageDescription' | translate"
/>

<ul class="nav nav-tabs nav-bordered mb-3">
  <li class="nav-item">
    <a
      class="nav-link active"
      id="labels-tab"
      data-bs-toggle="tab"
      data-bs-target="#labels"
      type="button"
      role="tab"
      aria-controls="labels"
      aria-selected="true"
    >
      <i class="mdi mdi-home-variant d-md-none d-block"></i>
      <span class="d-none d-md-block">{{ 'tag.list.tabLabels' | translate }}</span>
    </a>
  </li>
  <li class="nav-item">
    <a
      class="nav-link"
      id="custom-fields-tab"
      data-bs-toggle="tab"
      data-bs-target="#custom-fields"
      type="button"
      role="tab"
      aria-controls="custom-fields"
      aria-selected="false"
    >
      <i class="mdi mdi-account-circle d-md-none d-block"></i>
      <span class="d-none d-md-block">{{ 'tag.list.tabCustomFields' | translate }}</span>
    </a>
  </li>
  <li class="nav-item">
    <a
      class="nav-link"
      id="tab-tab"
      data-bs-toggle="tab"
      data-bs-target="#tab"
      type="button"
      role="tab"
      aria-controls="tab"
      aria-selected="false"
    >
      <i class="mdi mdi-settings-outline d-md-none d-block"></i>
      <span class="d-none d-md-block">{{ 'tag.list.tabClosingReason' | translate }}</span>
    </a>
  </li>
  <li class="nav-item">
    <a
      class="nav-link"
      id="lead-origin-tab"
      data-bs-toggle="tab"
      data-bs-target="#lead-origin"
      type="button"
      role="tab"
      aria-controls="lead-origin"
      aria-selected="false"
    >
      <i class="mdi mdi-source-branch d-md-none d-block"></i>
      <span class="d-none d-md-block">{{ 'tag.list.tabLeadOrigin' | translate }}</span>
    </a>
  </li>
</ul>

<div class="tab-content" id="tabComponentsContent">
  <div
    class="tab-pane fade show active"
    id="labels"
    role="tabpanel"
    aria-labelledby="labels-tab"
  >
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <form [formGroup]="formGroup">
              <div class="row">
                <div class="col-xs-12 col-md-9 input-trend-search">
                  <input
                    type="search"
                    #searchBox
                    class="form-control"
                    [placeholder]="'tag.list.searchPlaceholder' | translate"
                    formControlName="search"
                    (keyup)="search(searchBox.value)"
                  />
                  <span class="mdi mdi-magnify search-icon ml-2"></span>
                </div>

                <div class="col-xs-12 col-lg-3 btn-group trend-button">
                  <button class="btn btn-info fw-bold" (click)="add()">
                    {{ 'tag.list.addButton' | translate }}
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>

    @if (loadingContent) {
      <content-loading-list />
    }

    @if (pager.total == 0) {
      <empty-records-component
        [message]="'tag.list.emptyMessage' | translate"
        [subMessage]="'tag.list.emptySubMessage' | translate"
        [icon]="'mdi mdi-alert-circle-outline'"
         [labelButton]="'tag.list.emptyButton' | translate"
        (emitEvent)="add()"
      />
    }

    @if (!loadingContent && pager.total > 0) {
      <div class="card">
        <div class="card-body table-responsive">
          <table class="table table-hover table-centered mb-0">
            <thead>
              <tr>
                <th class="text-primary-emphasis">{{ 'tag.list.columnTag' | translate }}</th>
                <th class="text-primary-emphasis">{{ 'tag.list.columnCreatedAt' | translate }}</th>
                <th class="text-primary-emphasis">{{ 'tag.list.columnKeywords' | translate }}</th>
                <th><span class="sr-only"></span></th>
              </tr>
            </thead>
            <tbody>
              @for (item of pager.list; track $index) {
                <tr>
                  <td>
                    <span
                      class="badge font-14 text-capitalize"
                      [ngStyle]="{
                        'background-color': item.bgColor,
                        color: (item.bgColor | readableText: item.fontColor),
                      }"
                    >
                      {{ item.title }}
                    </span>
                  </td>
                  <td>
                    <div>
                      <div>
                        <span>{{
                          item.createdAt
                            | timezoneDate
                              : "DD/MM/YYYY"
                              : getTimezoneCompanyCurrentUser()
                        }}</span>
                      </div>
                    </div>
                  </td>
                  <td>
                    @for (tag of item.keyword; track $index) {
                      <span class="badge font-14 bg-info text-capitalize">{{
                        tag
                      }}</span>
                    }
                  </td>
                  <td>
                    <div class="d-flex justify-content-end">
                      <button
                        type="button"
                        class="btn btn-dropdown-list"
                        [matMenuTriggerFor]="menu"
                      >
                        <i
                          class="mdi mdi-dots-vertical text-primary-emphasis"
                        ></i>
                      </button>

                      <mat-menu #menu="matMenu">
                        <button mat-menu-item tabindex="0" (click)="edit(item)">
                          {{ 'tag.list.menuEdit' | translate }}
                        </button>
                        @if (isAdmin()) {
                          <button
                            mat-menu-item
                            tabindex="0"
                            (click)="delete(item)"
                          >
                            {{ 'tag.list.menuRemove' | translate }}
                          </button>
                        }
                      </mat-menu>
                    </div>
                  </td>
                </tr>
              }
            </tbody>
          </table>
          @if (pager.total > pager.perPage) {
            <paginator [pager]="pager" (onPager)="loadPage($event)" />
          }
        </div>
      </div>
    }
  </div>

  <div
    class="tab-pane fade"
    id="custom-fields"
    role="tabpanel"
    aria-labelledby="custom-fields-tab"
  >
    <custom-field-component />
  </div>
  <div class="tab-pane fade" id="tab" role="tabpanel" aria-labelledby="tab-tab">
    <app-tabulation />
  </div>
  <div
    class="tab-pane fade"
    id="lead-origin"
    role="tabpanel"
    aria-labelledby="lead-origin-tab"
  >
    <app-lead-source />
  </div>
</div>
